const resourceFeatured = document.querySelectorAll(
  '.e-psq--resource-featured > .e-sgp, .e-psq--blog-featured > .e-sgp'
);

if ( resourceFeatured.length > 0 ) {
  const spanCount = resourceFeatured.length;
  resourceFeatured[0].style.setProperty( '--spanCount', spanCount - 1 );
}
